import { render, staticRenderFns } from "./TransferToAccountingModal.vue?vue&type=template&id=4908f8d2&scoped=true"
import script from "./TransferToAccountingModal.vue?vue&type=script&lang=js"
export * from "./TransferToAccountingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908f8d2",
  null
  
)

export default component.exports